import React from 'react';
import { Calendar } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { blogPosts } from '../mock';
import { Card, CardContent } from './ui/card';

const BlogSection = () => {
  const { language } = useLanguage();
  const posts = blogPosts[language];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {language === 'en' ? 'Our Latest Blogs' : 'Nuestros Últimos Blogs'}
          </h2>
          <p className="text-xl text-gray-600">
            {language === 'en' 
              ? 'Please read our new articles to save more!'
              : '¡Lea nuestros nuevos artículos para ahorrar más!'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <Card
              key={post.id}
              className="group hover:shadow-2xl transition-all duration-300 cursor-pointer overflow-hidden border-none"
            >
              <div className="relative overflow-hidden h-56">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <span className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {post.category}
                </span>
              </div>
              <CardContent className="p-6 space-y-3">
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <Calendar className="w-4 h-4" />
                  <span>{post.date}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-700 transition-colors line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 line-clamp-3">{post.excerpt}</p>
                <button className="text-blue-700 font-semibold group-hover:gap-2 inline-flex items-center gap-1 transition-all">
                  {language === 'en' ? 'Read More' : 'Leer Más'}
                  <span className="group-hover:translate-x-1 transition-transform">→</span>
                </button>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300">
            {language === 'en' ? 'View All Articles' : 'Ver Todos los Artículos'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;